import {
  ExamRoomRequestComputerInfoDetails,
  ExamLocationRequestRoomComputerInfoForm,
  mapComputerInfoToDefaultValues,
  useExamRoomRequestInfo,
} from '@exam-center/exam-location-management';
import { ExamLocationRequestWorkflowStepCode } from '@exam-center/graphql';
import { PaperSection } from '@shared/components';

export default function ExamLocationRequestRoomComputerInfoEditPage() {
  const { examRoomRequestInfo, isReadonly } = useExamRoomRequestInfo();

  const defaultValues = mapComputerInfoToDefaultValues(
    examRoomRequestInfo.examRoomRequestComputerInfo?.info,
  );

  return (
    <PaperSection title='ข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์'>
      {examRoomRequestInfo.step ===
      ExamLocationRequestWorkflowStepCode.ExamLocationRequestRejected ? (
        <ExamLocationRequestRoomComputerInfoForm
          isReadonly={isReadonly}
          defaultValues={defaultValues}
        />
      ) : (
        <ExamRoomRequestComputerInfoDetails />
      )}
    </PaperSection>
  );
}
